export default {
  overrideRequest: function (axiosConfig) {

  },

  confirmbetslipusingconfirmations: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },

  confirmbetslipusingconfirmationsasync: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },

  updatebetslipselections: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },

  placebetslip: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },

  placebetslipasync: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },

  getallowedbettypesandreturns: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },

  processallowedbettypes: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },

  getinrunningdelay: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },

  calculatebetslip: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },

  rejectbetslip: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  }
}



// WEBPACK FOOTER //
// ./src/library/rpcService/api/services/FixedOddsBetting.js